import desktopHide from './desktop-hide';

/**
 * Creates an event listener for desktop menu mouse leave events.
 *
 * This function returns an event listener that hides the target menu after a specified delay.
 * It sets a timeout to remove the active class from the element and hide the menu.
 *
 * @param {HTMLElement} el - The element that triggers the mouse leave event.
 * @param {HTMLElement} menu - The menu element to hide.
 * @param {Object} params - Configuration parameters.
 * @param {number} params.delay - The delay before hiding the menu.
 * @param {Object} itemParams - Item-specific parameters.
 * @param {Function} itemParams.activeItemClass - A function that returns the active item class.
 * @param {number} itemParams.megaMenuTimeOut - Timeout ID for the mega menu.
 * @returns {Function} - The event listener function.
 */
export default function desktopMouseLeaveEventListener(el, menu, params, itemParams) {
  return function () {
    itemParams.megaMenuTimeOut = setTimeout(function () {
      el.classList.remove(itemParams.activeItemClass().slice(1));
      desktopHide(el, menu, params, itemParams);
    }, params.delay);
  };
}
